import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyB9kanevbsolQ8-KgyzHUg09ZkXBAOdGKg',
  authDomain: 'flow-mobile-e7a07.firebaseapp.com',
  projectId: 'flow-mobile-e7a07',
  storageBucket: 'flow-mobile-e7a07.appspot.com',
  messagingSenderId: '15826011991',
  appId: '1:15826011991:web:b4f3455652f535e2252012',
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
export const auth = getAuth(app);
